import {
  FaTwitter,
  FaYoutube,
  FaInstagram,
  FaTiktok,
  FaLinkedinIn,
  FaEnvelope,
  FaMapMarkerAlt,
  FaApple,
  FaGooglePlay,
} from 'react-icons/fa';
import logo from '@src/assets/images/logo/logo-round.png';
import '@src/@core/scss/layouts/footer/primary-footer.scss';
import { List, ListInlineItem } from 'reactstrap';
import appConfig from '@src/configs/appConfig';

const spaccurateCorporateBaseUrl = appConfig.urls.CORPORATE_WEB_APP;

const PrimaryFooter = () => {
  return (
    <>
      <section className="primary-footer-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="footer-about-area">
                <div className="logo">
                  <a href="/">
                    <img src={logo} style={{ maxBlockSize: '5em' }} alt="" />
                  </a>
                </div>
                <p>
                  SPACCURATE is a sophistocated pricing engine that was built to
                  empower both the consumer and therapist.
                </p>
                <a href={spaccurateCorporateBaseUrl}>
                  Read More <i className="fal fa-arrow-right" />
                </a>
                <div className="social mt-30">
                  <List>
                    <ListInlineItem>
                      <a
                        href="https://twitter.com/spaccurate"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaTwitter size="30px" />
                      </a>
                    </ListInlineItem>
                    <ListInlineItem>
                      <a
                        href="https://www.instagram.com/spaccurate"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaInstagram size="30px" />
                      </a>
                    </ListInlineItem>
                    <ListInlineItem>
                      <a
                        href="https://www.tiktok.com/@spaccurate"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaTiktok size="30px" />
                      </a>
                    </ListInlineItem>
                    <ListInlineItem>
                      <a
                        href="https://www.linkedin.com/company/spaccurate"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaLinkedinIn size="30px" />
                      </a>
                    </ListInlineItem>
                    <ListInlineItem>
                      <a
                        href="https://www.youtube.com/@spaccurate"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaYoutube size="30px" />
                      </a>
                    </ListInlineItem>
                  </List>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="footer-navigation-area">
                <h4 className="title">Company</h4>
                <ul>
                  <li>
                    <a href={spaccurateCorporateBaseUrl}>About Us</a>
                  </li>
                  <li>
                    <a
                      href={`${spaccurateCorporateBaseUrl}/terms-and-conditions`}
                    >
                      Terms and Conditions
                    </a>
                  </li>
                  <li>
                    <a href={`${spaccurateCorporateBaseUrl}/privacy-policy`}>
                      Privacy
                    </a>
                  </li>
                  <li>
                    <a href={`${spaccurateCorporateBaseUrl}/contact`}>
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="footer-contact-area">
                <h4 className="title">Get In Touch</h4>
                <List>
                  <li>
                    <a href="mailto:support@spaccurate.com">
                      <FaEnvelope size="20px" /> SUPPORT@SPACCURATE.com
                    </a>
                  </li>
                  <li>
                    <a
                      href="http://maps.google.com/?q=6045 Barfield Road #150, Sandy Springs, GA"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaMapMarkerAlt size="20px" /> 6045 Barfield Road
                      <br /> Suite 150
                      <br /> Sandy Springs, GA 30328
                    </a>
                  </li>
                </List>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div
                className="
                footer-copyright
                d-flex
                align-items-center
                justify-content-between
                pt-35
              "
              >
                <List className="download-btns">
                  <ListInlineItem>
                    <a
                      className="download-btn"
                      href="https://apps.apple.com/us/app/spaccurate-spa-accurate-rate/id1661816920"
                    >
                      <FaApple size="20px" className="download-icon" /> Download
                      for iOS
                    </a>
                  </ListInlineItem>
                  <ListInlineItem>
                    <a
                      className="download-btn"
                      href="https://play.google.com/store/apps/details?id=com.spaccurate.customer_mobile"
                    >
                      <FaGooglePlay size="20px" className="download-icon" />{' '}
                      Download for Android
                    </a>
                  </ListInlineItem>
                </List>
                <div className="copyright-text">
                  <p>
                    Copyright © {new Date().getFullYear()} SPACCURATE INC. All
                    rights reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrimaryFooter;
